// types
import { ISecurityProfilePermissions, SecurityProfileReviewPermission } from 'types/graphql'
// utils
import keys from 'lodash/keys'
import forEach from 'lodash/forEach'

export const mergePermissions = (permissions: ISecurityProfilePermissions[]) => {
  return permissions.reduce(
    (acc: ISecurityProfilePermissions, curr: ISecurityProfilePermissions): ISecurityProfilePermissions => {
      forEach(keys(curr), (key: string) => {
        switch (curr[key]) {
          case SecurityProfileReviewPermission.All:
            acc[key] = curr[key]
            break
          case SecurityProfileReviewPermission.Own:
            acc[key] = acc[key] === SecurityProfileReviewPermission.All ? acc[key] : curr[key]
            break
          default:
            acc[key] = acc[key] || curr[key]
        }
      })

      return acc
    },
    {}
  )
}
